import script from "./AuthorityDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthorityDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AuthorityDialog.vue?vue&type=style&index=0&id=21341f9e&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21341f9e"]])

export default __exports__